module.exports = __webpack_public_path__ + "img/five.0a26641a.png";